import classNames from 'classnames';
import { initialState } from 'mastodon/initial_state';

export const WordmarkLogo: React.FC = () => (
  <span className='dr-wordmark' role='img' aria-label='skyhaven.social'>
    <img src={initialState?.meta.header_app_icon || '/driscoll/v11/logo.jpg'} alt='' />
    <strong>skyhaven.social</strong>
  </span>
);

// Keep the technology attribution symbol in embeds; the actual application
// wordmark and navigation symbol use our brand, not Mastodon's identity.
export const IconLogo: React.FC<{ className?: string }> = ({ className }) => (
  <svg viewBox='0 0 79 79' className={classNames('logo logo--icon', className)} role='img'>
    <title>Mastodon</title>
    <use xlinkHref='#logo-symbol-icon' />
  </svg>
);

export const SymbolLogo: React.FC = () => (
  <img src={initialState?.meta.header_app_icon || '/driscoll/v11/logo.jpg'} alt='skyhaven.social' className='logo logo--icon' />
);
